import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch } from '@angular/common/http';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),  // Configure Zone.js change detection
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),  // Provide routes for the app
    provideClientHydration(),  // For hydration in server-side rendering
    provideAnimationsAsync(),  // Async animations support
    importProvidersFrom(HttpClientModule),  // Import HttpClientModule
    provideHttpClient(withFetch()),  // HTTP client with fetch setup
  ]
};
